// src/components/Login.js

import React, { useState } from 'react';
import '../styles/Login.css';

const Login = ({ setAuth }) => {
    // Determine auth service URL - adjust based on environment
    const getAuthServiceURL = () => {
        const hostname = window.location.hostname;
        if (hostname === 'localhost' || hostname === '127.0.0.1') {
            return 'http://localhost:4001'; // Local testing
        }
        // Production/Testing - use same root domain
        return `https://auth.${hostname.split('.').slice(-3).join('.')}`;
    };
    
    const AUTH_SERVICE_URL = getAuthServiceURL();
    
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [show2FA, setShow2FA] = useState(false);
    const [tfaCode, setTfaCode] = useState('');
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handlePasswordSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setIsLoading(true);
        try {
            const response = await fetch(`${AUTH_SERVICE_URL}/auth/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ email, password })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error);
            
            setShow2FA(true);
            setMessage(data.message);
        } catch (error) {
            setMessage(error.message || 'Login failed');
        } finally {
            setIsLoading(false);
        }
    };

    const handle2faSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setIsLoading(true);
        try {
            const response = await fetch(`${AUTH_SERVICE_URL}/auth/verify-otp`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ email, otp: tfaCode })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error);
            
            // Force full page reload to pick up SSO cookie
            window.location.href = window.location.origin;
        } catch (error) {
            setMessage(error.message || 'Invalid OTP');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="card login-form-card">
                <h2 className="login-title">MyBrandz Device & Password Portal Login</h2>
                
                {!show2FA ? (
                    <form onSubmit={handlePasswordSubmit}>
                        <div className="form-group">
                            <label className="modal-label">Email:</label>
                            <input 
                                type="email" 
                                value={email} 
                                onChange={(e) => setEmail(e.target.value)} 
                                required 
                                disabled={isLoading}
                            />
                        </div>
                        <div className="form-group">
                            <label className="modal-label">Password:</label>
                            <input 
                                type="password" 
                                value={password} 
                                onChange={(e) => setPassword(e.target.value)} 
                                required 
                                disabled={isLoading}
                            />
                        </div>
                        <button type="submit" className="login-button" disabled={isLoading}>
                            {isLoading ? 'Logging in...' : 'Login'}
                        </button>
                    </form>
                ) : (
                    <form onSubmit={handle2faSubmit}>
                        <p className="message info">A 6-digit code has been sent to your email.</p>
                        <div className="form-group">
                            <label className="modal-label">Authentication Code:</label>
                            <input 
                                type="text" 
                                value={tfaCode} 
                                onChange={(e) => setTfaCode(e.target.value)} 
                                required 
                                disabled={isLoading}
                                maxLength="6"
                                placeholder="123456"
                            />
                        </div>
                        <button type="submit" className="login-button" disabled={isLoading}>
                            {isLoading ? 'Verifying...' : 'Verify'}
                        </button>
                    </form>
                )}

                {message && <p className={`message ${message.includes('sent') ? 'info' : 'error'}`}>{message}</p>}
            </div>
        </div>
    );
};

export default Login;
